module.exports = __webpack_public_path__ + "img/9-Industrial Technology Research Institute.0557603d.png";